import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SatvicFood from '../../assets/satvic-food.png';
import { pageAction } from '../../redux_files/actions/page_actions';
import { PHONE_NUMBER_WITH_PREFIX } from '../../utils/constants';

const SatvicBuffet = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Satvic Buffet';
    dispatch(pageAction('Satvic Buffet'));
  });

  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          <div className='food-images-grid'>
              <div style={{
                cursor: 'pointer',
                border: '2px solid var(--color-border)',
                background: 'var(--color-white)',
                color: 'var(--color-text-primary)',
                borderRadius: '12px',
                padding: '10px',
                minWidth: '180px',
                minHeight: '120px',
                width: '220px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: '18px',
                transition: 'all 0.2s',
              }}>Pure Desi Ghee Food is also available on request</div>
            {[
              { src: SatvicFood, alt: 'Satvic Food', label: 'Satvic Buffet', value: 'satvicBuffet', description: 'A healthy satvic thali with organic ingredients.', extra: '(without onion and garlic)', price: 100
               },
            ].map(({ src, alt, label, description, extra, price }, idx) => (
              <div key={label} className='food-image-block'>
                <img src={src} alt={alt} className='food-image' />
                <div className='food-image-label'>{label}</div>
                 <div className="step-tile-desc">{description}
                {extra && (
                  <div className="step-tile-extra">{extra}</div>
                )}
              </div>
               <div className="step-tile-price">{ price ? `₹${price}/plate` : ''}</div>
              </div>
            ))}
          </div>
           <div className="infoNew">
          Note: Please specify your preference when you call to book.
        </div>
        <div className="infoNote">
          Note: Additional charges will apply for any extra food items or cutlery.
        </div>
        </div>
        <a
          href={`tel:${PHONE_NUMBER_WITH_PREFIX}`}
          className="primary-button step-button mt-20"
          style={{ textAlign: 'center', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          Click to book
        </a>
      </div>
    </>
  );
};

export default SatvicBuffet;
